import { useCallback, useMemo } from 'react';

import { useSelector } from '@hh.ru/front-static-app';
import { usePush } from '@hh.ru/redux-spa-middleware';

import { getCurrentRouteHrefWithoutParam, getCurrentRouteHrefWithParam } from 'src/app/routesUtils/functions';

function useQueryParamAsState(key: string): [string, (value: string | null) => void] {
    const location = useSelector((state) => state.router.location);
    const push = usePush();
    const value = useMemo(() => location.query?.[key], [location, key]);

    const setValue = useCallback(
        (newValue: string | null) => {
            if (!newValue) {
                push(getCurrentRouteHrefWithoutParam(location, key), {
                    cancelScrollCorrection: true,
                });
                return;
            }
            push(getCurrentRouteHrefWithParam(location, key, newValue), {
                cancelScrollCorrection: true,
            });
        },
        [location, push, key]
    );

    return [value, setValue];
}
export default useQueryParamAsState;
